import React, { useState, useEffect } from "react";
import { io } from "socket.io-client";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import axios from "axios";
import SyncProgress from "./SyncProgress";
import { useSync } from "../context/SyncContext";
import { Box } from "@mui/material";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

// action
import {
  getTradesData,
  getTradesFromDatabase,
  setTradesLoading,
  setTradesLoadingFinished,
  setResetLoading,
  setReportsLoadingFinished
} from "../../actions/tradesActions";
import {TRADES_LOADING, CLEAR_ERRORS } from "../../actions/types";
// mui
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputAdornment from "@mui/material/InputAdornment";
import SettingsIcon from "@mui/icons-material/Settings";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import SyncIcon from '@mui/icons-material/Sync';

import AutoComplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
// components
import MainLayout from "../../layouts/full/mainlayout";
import Spinner from "../common/Spinner";
// metatraderJSON
import metaServerData from "../../config/metatraderServerNames.json";
import metaBrokerData from "../../config/metatraderBrokers.json";

const brokers = ["Siigo", "Alegra","Effi","Siigo inventario","Odoo"];
// oanda
const dataRanges = ["All Trades", "Latest Trades"];
const timezones = ["DO NOT CONVERT"];
// metatrader
const metatraderTypes = ["mt4", "mt5"];


function delay(duration) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, duration);
  });
}




export default function BrokerSync() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const expired = useSelector((store) => store.auth.user.expired);
  const userId = useSelector((store) => store.auth.user.public_id);
  const loading = useSelector((store) => store.trades.loading);
  const loadinFinish = useSelector((store) => store.trades.loadinFinished);
  const [autorizado, setAutorizado] = useState(false);

  useEffect(() => {
  if (loadinFinish) {
    dispatch(setResetLoading());
    navigate("/charts");
  }
}, [loadinFinish,navigate, dispatch]);



  useEffect(() => {  
    if (expired) {
      navigate("/profile/account_plan");
      enqueueSnackbar("Your Account is Expired", {
        variant: "error",
      });
    }
  }, [expired, navigate, enqueueSnackbar]);

  
  // message
  const [message, setMessage] = useState("");

  const [broker, setBroker] = useState("");
  // oanda
  const [apiKey, setApiKey] = useState("");
  const [accountId, setAccountId] = useState("");
  const [dataRange, setDataRange] = useState("Latest Trades");
  const [timezone, setTimezone] = useState("DO NOT CONVERT");
  // metatrader
  const [mtValue, setMtValue] = useState("");
  const [mtLoginId, setMtLoginId] = useState("");
  const [mtPassword, setMtPassword] = useState("");

  const [url,setUrl]=useState("");
  const [db,setDb]=useState("");
  const [empresa,setEmpresa]=useState("");

  const [mtBroker, setMtBroker] = useState("");
  const [mtServer, setMtServer] = useState("");
  const [CheckedData, setCheckedData] = useState(true);

  const [serverOpen, setServerOpen] = useState(false);
  const [brokerOpen, setBrokerOpen] = useState(false);
  const [metatraderServers, setMetatraderServers] = useState([]);
  const [metatraderBrokers, setMetatraderBrokers] = useState([]);
  const serverLoading = serverOpen && metatraderServers.length === 0;
  const brokerLoading = brokerOpen && metatraderBrokers.length === 0;

  const [user_siigo, setUserSiigo] = useState();
  const [password_siigo, setPasswordSiigo] = useState();
  const [files, setFiles] = useState([]);
  const [error, setError] = useState('');
  const [progress, setProgress] = useState(0);
  const [messages, setMessages] = useState("");
  const [openSync, setOpenSync] = useState(false);
  //const { progress1, message1 } = useSync();
  const { progress1, setProgress1, message1, setMessage1 } = useSync();
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(""); // año seleccionado actualmente
  const [filesByYear, setFilesByYear] = useState({}); // { "2024": [file1, file2], "2025": [file3] }
  

  const handleUpload = async () => {
  const formData = new FormData();

  files.forEach((file) => {
    formData.append("files", file);
  });

  await fetch("/api/upload", {
    method: "POST",
    body: formData,
  });
};

 const handleRegionesAsesores = async () => {

     try {
    setMessage1("Connectando a las regiones/asesores...");
    dispatch(setTradesLoading());

   const connectAccount = await axios.post(
              "/api/region_y_por_asesor",
              {
                user: userId
              },
              {
                timeout: 0
              }
            );
            if (connectAccount.data.success) {
              enqueueSnackbar(
                `Sincronización iniciada`,
                {
                  variant: "success",
                }
              );
              //navigate("/charts");
      
            } else {
              enqueueSnackbar("No se pudo iniciar el proceso", {
                variant: "error",
              });
              dispatch({ type: CLEAR_ERRORS });
           //   dispatch(
            //    getTradesFromDatabase({ user: userId }, enqueueSnackbar)
            //  );
            //  navigate("/tradestable");
            }
     }
     catch (err) {
    alert(`Error en la petición de:`, err);
    console.log("ERROR:", err);

    if (err.response) {
      console.log("Backend respondió:", err.response.data);
    }

    if (err.request) {
      console.log("No hubo respuesta del backend");
    }

    console.log(err.message);
  }
           // dispatch(setTradesLoadingFinished());
 }
   // Función para manejar la carga del archivo
  const handleFileUpload = async () => {
  if (Object.keys(filesByYear).length === 0) {
    setError("No hay archivos para subir");
    return;
  }

  setError("");

  const formData = new FormData();
  const metadata = {};

  Object.entries(filesByYear).forEach(([year, files]) => {
    metadata[year] = [];
    files.forEach((file, idx) => {
      const key = `${year}_${idx}_${file.name}`;
      metadata[year].push(key);
      formData.append("files", file, key);
    });
  });

formData.append("metadata", JSON.stringify(metadata));
formData.append("user",userId)



  try {
    setMessage1("Connecting the account to Siigo...");
    dispatch(setTradesLoading());
    const response = await fetch("/api/upload", {
      method: "POST",
      body: formData,
    });

    if (response.ok) {
      enqueueSnackbar(
                `Successfully loaded data`,
                {
                  variant: "success",
                }
              );
      navigate("/charts");
    } else {
      alert(`Error al subir archivos`);
    }
  } catch (err) {
    alert(`Error en la petición de:`, err);
  }
  
  dispatch(setTradesLoadingFinished());
  // Reset si quieres
  setFilesByYear({});
  setSelectedYear("");
};



  // Función para manejar el cambio en el archivo seleccionado
  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;

    // Validar que se haya seleccionado un archivo
    if (selectedFiles) {
      setFiles([...selectedFiles]);
      setError('');
    } else {
      setFiles(null);
    }
  };


  useEffect(() => {
    let active = true;
    if (!brokerLoading) return undefined;
    (async () => {
      if (active) {
        if (mtValue === "mt4") {
          setMetatraderBrokers(
            metaBrokerData.filter((data) => {
              const ids = metaServerData
                .filter((server) => server.mt4 === 1)
                .map((filtered) => filtered.fk_broker_id);
              const uniq = [...new Set(ids)];
              return uniq.includes(data.id);
            })
          );
        } else {
          setMetatraderBrokers(
            metaBrokerData.filter((data) => {
              const ids = metaServerData
                .filter((server) => server.mt5 === 1)
                .map((filtered) => filtered.fk_broker_id);
              const uniq = [...new Set(ids)];
              return uniq.includes(data.id);
            })
          );
        }
      }
      await delay(1e3);
    })();
    return () => {
      active = false;
    };
  }, [mtValue, brokerLoading]);

 
  useEffect(() => {
    (async () => {
 await  axios.post(
    "/api/siigo_validate_credentials",
    {
      user: userId
    }
    
  ).then((res) => {
    const { tieneData,user_siigo,password_siigo} = res.data;
  
    setCheckedData(tieneData);
    setUserSiigo(user_siigo)
    setPasswordSiigo(password_siigo)
  
  })
})();},[])
 

  useEffect(() => {
    let serverActive = true;
    if (!serverLoading) return undefined;
    (async () => {
      if (serverActive) {
        if (mtValue === "mt4") {
          setMetatraderServers(
            metaServerData.filter(
              (server) =>
                server.fk_broker_id ===
                  metaBrokerData.find((broker) => broker.name === mtBroker)
                    .id && server.mt4 === 1
            )
          );
        } else {
          setMetatraderServers(
            metaServerData.filter(
              (server) =>
                server.fk_broker_id ===
                  metaBrokerData.find((broker) => broker.name === mtBroker)
                    .id && server.mt5 === 1
            )
          );
        }
      }
      await delay(1e3);
    })();
    return () => {
      serverActive = false;
    };
  }, [mtBroker, mtValue, serverLoading]);

  useEffect(() => {
    if (!brokerOpen) setMetatraderBrokers([]);
  }, [brokerOpen]);

  useEffect(() => {
    if (!serverOpen) setMetatraderServers([]);
  }, [serverOpen]);
  
  const [settings, setSettings] = useState("");

  const [dialogOpen, setDialogOpen] = useState(false);
  const handleClickDialogOpen = () => {
    setDialogOpen(true);
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
    setApiKey("");
    setAccountId("");
    setDataRange("Latest Trades");
    setTimezone("DO NOT CONVERT");
    setMtValue("");
    setMtLoginId("");
    setMtPassword("");
    setMtBroker("");
    setMtServer("");
    setUrl("");
    setDb("");
    
  };

  const renderOanda = (
    <>
      <DialogContent dividers>
        <Stack direction="column" spacing={2} p={1}>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={12} sm={4}>
              <Typography>Enter Api Key</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                value={apiKey}
                onChange={(e) => setApiKey(e.target.value)}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={12} sm={4}>
              <Typography>Enter account number ID</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                value={accountId}
                onChange={(e) => setAccountId(e.target.value)}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={12} sm={4}>
              <Typography>Select the data range to import</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <FormControl fullWidth>
                <Select
                  labelId="datarange"
                  value={dataRange}
                  onChange={(e) => setDataRange(e.target.value)}
                >
                  {dataRanges.map((dataRange, index) => (
                    <MenuItem key={index} value={dataRange}>
                      {dataRange}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={12} sm={4}>
              <Typography>Select Timezone</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <FormControl fullWidth>
                <Select
                  labelId="timezone"
                  value={timezone}
                  onChange={(e) => setTimezone(e.target.value)}
                >
                  {timezones.map((timezone, index) => (
                    <MenuItem key={index} value={timezone}>
                      {timezone}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Stack spacing={0.5} color="dimgrey">
            <Typography>
              <b>Instructions:</b>
            </Typography>
            <Typography>
              1. Paste that code in the box above and click on "Connect
            </Typography>
            <Typography pl={2}>
              Note: You can get the API code by logging into your account,
              navigating to "My account" and then click on "Manage API access"
              and generate the API code.
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          disabled={
            apiKey.trim().length === 0 ||
            accountId.trim().length === 0 ||
            broker.trim().length === 0
          }
          sx={{ m: 1, bgcolor: "#0094b6" }}
          onClick={() => {
            setMessage("Importing data from oanda...");
            dispatch(
              getTradesData(
                {
                  broker,
                  key: apiKey,
                  id: accountId,
                  user: userId,
                },
                navigate,
                enqueueSnackbar
              )
            );
            handleDialogClose();
          }}
        >
          Connect
        </Button>
      </DialogActions>
    </>
  );

   const renderEffi = (
    <>
      <DialogContent dividers>
        <Stack spacing={2} p={1}>
          <Grid container spacing={1} alignItems="center">
         
          </Grid>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={12} sm={4}>
              <Typography>Enter Effi User Name</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                value={mtLoginId}
                onChange={(e) => setMtLoginId(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography>Enter Effi Password</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                value={mtPassword}
                onChange={(e) => setMtPassword(e.target.value)}
              />
            </Grid>
          </Grid>

       


      
         
        
        
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          disabled={
       
            mtLoginId.trim().length === 0 
          }
          sx={{ m: 1, bgcolor: "#0094b6" }}
          onClick={async () => {
            handleDialogClose();
            setMessage("Connecting the account to Effi...");
            dispatch(setTradesLoading());
            const connectAccount = await axios.post(
              "/api/effi_rpa",
              {
                user: userId,
                id: mtLoginId,
                pass: mtPassword
              },
              //{
                //responseType: "blob"  // ⚠️ Esto es esencial
              //}
            )
            //const blob = new Blob([connectAccount.data], {
              //  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              //});

              //const url = window.URL.createObjectURL(blob);
              //const a = document.createElement("a");
              //a.href = url;
              //a.download = "articulos_exportados.xlsx"; // nombre del archivo descargado
              //document.body.appendChild(a);
              //a.click();
              //a.remove();
              //window.URL.revokeObjectURL(url);
            
          
            
            if (connectAccount.data.success) {
              enqueueSnackbar(
                `Successfully loaded data`,
                {
                  variant: "success",
                }
              );
              navigate("/inventoryCharts",
                  {
                  state: {
                    fromEffi: true, // 👈 aquí pasas tu variable
                    extraData: connectAccount.data.algo // opcional
                  }
                }
              );
            {/*
              setMessage("Getting reports...");
              const response = await axios.post("/api/import_reports_siigo", {
                user: userId,
                saldo: connectAccount.data.saldo,
                costoV:connectAccount.data.costoV,
                costoM:connectAccount.data.costoM,
                utilidad:connectAccount.data.utilidad,
                gastosAdmon:connectAccount.data.gastosAdmon,
                gastosPer:connectAccount.data.gastosPer,
                gastosHono:connectAccount.data.gastosHono,
                gastosImp:connectAccount.data.gastosImp,
                gastosArrend:connectAccount.data.gastosArrend,
                gastosServ:connectAccount.data.gastosServ,
                gastosLegales:connectAccount.data.gastosLegales,
                gastosViaje:connectAccount.data.gastosViaje,
                gastosDiver:connectAccount.data.gastosDiver,
                margenBruto:connectAccount.data.margenBruto 
              });
          
                if (response.data.success) {
                  enqueueSnackbar(
                    `Successfully imported data`,
                    {
                      variant: "success",
                    }
                  );
                  dispatch({ type: CLEAR_ERRORS });
                  dispatch(
                    getTradesFromDatabase({ user: userId }, enqueueSnackbar)
                  );
                  navigate("/tradestable");
                } else {
                  enqueueSnackbar("Can't execute data from orders", {
                    variant: "error",
                  });
                  dispatch({ type: CLEAR_ERRORS });
                  dispatch(
                    getTradesFromDatabase({ user: userId }, enqueueSnackbar)
                  );
                  navigate("/tradestable");
                }
            */}
            } else {
              enqueueSnackbar("Can't connect to account", {
                variant: "error",
              });
              dispatch({ type: CLEAR_ERRORS });
           //   dispatch(
            //    getTradesFromDatabase({ user: userId }, enqueueSnackbar)
            //  );
            //  navigate("/tradestable");
            }
          
            dispatch(setTradesLoadingFinished());
          }}
        >
          Connect
        </Button>
      </DialogActions>
    </>
  );

const renderSiigoInventario = (
    <>
      <DialogContent dividers>
        <Stack spacing={2} p={1}>
          <Grid container spacing={1} alignItems="center">
         
          </Grid>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={12} sm={4}>
              <Typography>Enter Siigo User Name</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                value={mtLoginId}
                onChange={(e) => setMtLoginId(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography>Enter Siigo Password</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                value={mtPassword}
                onChange={(e) => setMtPassword(e.target.value)}
              />
            </Grid>
          </Grid>

       


      
         
        
        
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          disabled={
       
            mtLoginId.trim().length === 0 
          }
          sx={{ m: 1, bgcolor: "#0094b6" }}
          onClick={async () => {
            handleDialogClose();
            setMessage("Connecting the account to Siigo...");
            dispatch(setTradesLoading());
            const connectAccount = await axios.post(
              "/api/siigo_analisis_inventario",
              {
                user: userId,
                id: mtLoginId,
                pass: mtPassword
              },
              //{
                //responseType: "blob"  // ⚠️ Esto es esencial
              //}
            )
            //const blob = new Blob([connectAccount.data], {
              //  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              //});

              //const url = window.URL.createObjectURL(blob);
              //const a = document.createElement("a");
              //a.href = url;
              //a.download = "articulos_exportados.xlsx"; // nombre del archivo descargado
              //document.body.appendChild(a);
              //a.click();
              //a.remove();
              //window.URL.revokeObjectURL(url);
            
          
            
            if (connectAccount.data.success) {
              enqueueSnackbar(
                `Successfully loaded data`,
                {
                  variant: "success",
                }
              );
              navigate("/inventoryCharts",
                   {
                  state: {
                    fromSiigoInventory: true, // 👈 aquí pasas tu variable
                    extraData: connectAccount.data.algo // opcional
                  }
                }
              );
            {/*
              setMessage("Getting reports...");
              const response = await axios.post("/api/import_reports_siigo", {
                user: userId,
                saldo: connectAccount.data.saldo,
                costoV:connectAccount.data.costoV,
                costoM:connectAccount.data.costoM,
                utilidad:connectAccount.data.utilidad,
                gastosAdmon:connectAccount.data.gastosAdmon,
                gastosPer:connectAccount.data.gastosPer,
                gastosHono:connectAccount.data.gastosHono,
                gastosImp:connectAccount.data.gastosImp,
                gastosArrend:connectAccount.data.gastosArrend,
                gastosServ:connectAccount.data.gastosServ,
                gastosLegales:connectAccount.data.gastosLegales,
                gastosViaje:connectAccount.data.gastosViaje,
                gastosDiver:connectAccount.data.gastosDiver,
                margenBruto:connectAccount.data.margenBruto 
              });
          
                if (response.data.success) {
                  enqueueSnackbar(
                    `Successfully imported data`,
                    {
                      variant: "success",
                    }
                  );
                  dispatch({ type: CLEAR_ERRORS });
                  dispatch(
                    getTradesFromDatabase({ user: userId }, enqueueSnackbar)
                  );
                  navigate("/tradestable");
                } else {
                  enqueueSnackbar("Can't execute data from orders", {
                    variant: "error",
                  });
                  dispatch({ type: CLEAR_ERRORS });
                  dispatch(
                    getTradesFromDatabase({ user: userId }, enqueueSnackbar)
                  );
                  navigate("/tradestable");
                }
            */}
            } else {
              enqueueSnackbar("Can't connect to account", {
                variant: "error",
              });
              dispatch({ type: CLEAR_ERRORS });
           //   dispatch(
            //    getTradesFromDatabase({ user: userId }, enqueueSnackbar)
            //  );
            //  navigate("/tradestable");
            }
          
            dispatch(setTradesLoadingFinished());
          }}
        >
          Connect
        </Button>
      </DialogActions>
    </>
  );

const renderodoo = (
    <>
      <DialogContent dividers>
        <Stack spacing={2} p={1}>
          <Grid container spacing={1} alignItems="center">
         
          </Grid>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={12} sm={4}>
              <Typography>Enter Odoo User Name</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                value={mtLoginId}
                onChange={(e) => setMtLoginId(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography>Enter Odoo Api key</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                value={mtPassword}
                onChange={(e) => setMtPassword(e.target.value)}
              />
            </Grid>


              <Grid item xs={12} sm={4}>
              <Typography>Enter Odoo Url</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                value={url}
                onChange={(e) => setUrl(e.target.value)}
              />
            </Grid>

             <Grid item xs={12} sm={4}>
              <Typography>Enter Odoo DB</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                value={db}
                onChange={(e) => setDb(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
          <Typography>Tipo de empresa</Typography>
        </Grid>
        <Grid item xs={12} sm={8}>
          <FormControl fullWidth>
            <InputLabel>Seleccione una empresa</InputLabel>
            <Select
              value={empresa}
              label="Seleccione una empresa"
              onChange={(e) => setEmpresa(e.target.value)}
            >
              <MenuItem value="Restaurante">Restaurante</MenuItem>
              <MenuItem value="Fábrica">Fábrica</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      <div style={{ marginTop: "40px" }}>
       <FormControlLabel
        control={
          <Checkbox
            checked={autorizado}
            onChange={(e) => setAutorizado(e.target.checked)}
          />
        }
        label={
          <>
            Autorizo a Inlazuai a acceder y procesar los datos de Odoo
            necesarios para proporcionar los Insights.{" "}
            <a href="/politica-privacidad" target="_blank" rel="noreferrer">
              Política de privacidad
            </a>
          </>
        }
      />
      </div>
          </Grid>

       


      
         
        
        
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          disabled={
       
            mtLoginId.trim().length === 0 || !autorizado
          }
          sx={{ m: 1, bgcolor: "#0094b6" }}
          onClick={async () => {
            handleDialogClose();
            setMessage("Connecting the account to Siigo...");
            dispatch(setTradesLoading());
            const connectAccount = await axios.post(
              "/api/odoo_sync",
              {
                user: userId,
                id: mtLoginId,
                pass: mtPassword,
                url:url,
                db_name:db,
                tipo_empresa:empresa,
                autorizacion:autorizado
              },
              //{
                //responseType: "blob"  // ⚠️ Esto es esencial
              //}
            )
            //const blob = new Blob([connectAccount.data], {
              //  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              //});

              //const url = window.URL.createObjectURL(blob);
              //const a = document.createElement("a");
              //a.href = url;
              //a.download = "articulos_exportados.xlsx"; // nombre del archivo descargado
              //document.body.appendChild(a);
              //a.click();
              //a.remove();
              //window.URL.revokeObjectURL(url);
            
          
            
            if (connectAccount.data.success) {
              enqueueSnackbar(
                `Successfully loaded data`,
                {
                  variant: "success",
                }
              );
              navigate("/inventoryCharts",
                   {
                  state: {
                    fromOdooInventory: true, // 👈 aquí pasas tu variable
                    extraData: connectAccount.data.algo // opcional
                  }
                }
              );
            {/*
              setMessage("Getting reports...");
              const response = await axios.post("/api/import_reports_siigo", {
                user: userId,
                saldo: connectAccount.data.saldo,
                costoV:connectAccount.data.costoV,
                costoM:connectAccount.data.costoM,
                utilidad:connectAccount.data.utilidad,
                gastosAdmon:connectAccount.data.gastosAdmon,
                gastosPer:connectAccount.data.gastosPer,
                gastosHono:connectAccount.data.gastosHono,
                gastosImp:connectAccount.data.gastosImp,
                gastosArrend:connectAccount.data.gastosArrend,
                gastosServ:connectAccount.data.gastosServ,
                gastosLegales:connectAccount.data.gastosLegales,
                gastosViaje:connectAccount.data.gastosViaje,
                gastosDiver:connectAccount.data.gastosDiver,
                margenBruto:connectAccount.data.margenBruto 
              });
          
                if (response.data.success) {
                  enqueueSnackbar(
                    `Successfully imported data`,
                    {
                      variant: "success",
                    }
                  );
                  dispatch({ type: CLEAR_ERRORS });
                  dispatch(
                    getTradesFromDatabase({ user: userId }, enqueueSnackbar)
                  );
                  navigate("/tradestable");
                } else {
                  enqueueSnackbar("Can't execute data from orders", {
                    variant: "error",
                  });
                  dispatch({ type: CLEAR_ERRORS });
                  dispatch(
                    getTradesFromDatabase({ user: userId }, enqueueSnackbar)
                  );
                  navigate("/tradestable");
                }
            */}
            } else {
              /*enqueueSnackbar("Can't connect to account", {*/
              enqueueSnackbar("No se puede conectar la cuenta", {
                variant: "error",
              });
              dispatch({ type: CLEAR_ERRORS });
           //   dispatch(
            //    getTradesFromDatabase({ user: userId }, enqueueSnackbar)
            //  );
            //  navigate("/tradestable");
            }
          
            dispatch(setTradesLoadingFinished());
          }}
        >
          Connect
        </Button>
      </DialogActions>
    </>
  );


  const renderMetatrader = (
    <>
      <DialogContent dividers>
        <Stack spacing={2} p={1}>
          <Grid container spacing={1} alignItems="center">
         
          </Grid>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={12} sm={4}>
              <Typography>Enter Siigo User Name</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                value={mtLoginId}
                onChange={(e) => setMtLoginId(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography>Enter Siigo Password</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                value={mtPassword}
                onChange={(e) => setMtPassword(e.target.value)}
              />
            </Grid>
          </Grid>

       


      
         
        
        
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          disabled={
       
            mtLoginId.trim().length === 0 
          }
          sx={{ m: 1, bgcolor: "#0094b6" }}
          onClick={async () => {
            handleDialogClose();
            setMessage("Connecting the account to Siigo...");
            dispatch(setTradesLoading());
            const connectAccount = await axios.post(
              "/api/siigo_account",
              {
                user: userId,
                id: mtLoginId,
                pass: mtPassword
              }
            );
            if (connectAccount.data.success) {
              enqueueSnackbar(
                `Successfully loaded data`,
                {
                  variant: "success",
                }
              );
              navigate("/charts");
            {/*
              setMessage("Getting reports...");
              const response = await axios.post("/api/import_reports_siigo", {
                user: userId,
                saldo: connectAccount.data.saldo,
                costoV:connectAccount.data.costoV,
                costoM:connectAccount.data.costoM,
                utilidad:connectAccount.data.utilidad,
                gastosAdmon:connectAccount.data.gastosAdmon,
                gastosPer:connectAccount.data.gastosPer,
                gastosHono:connectAccount.data.gastosHono,
                gastosImp:connectAccount.data.gastosImp,
                gastosArrend:connectAccount.data.gastosArrend,
                gastosServ:connectAccount.data.gastosServ,
                gastosLegales:connectAccount.data.gastosLegales,
                gastosViaje:connectAccount.data.gastosViaje,
                gastosDiver:connectAccount.data.gastosDiver,
                margenBruto:connectAccount.data.margenBruto 
              });
          
                if (response.data.success) {
                  enqueueSnackbar(
                    `Successfully imported data`,
                    {
                      variant: "success",
                    }
                  );
                  dispatch({ type: CLEAR_ERRORS });
                  dispatch(
                    getTradesFromDatabase({ user: userId }, enqueueSnackbar)
                  );
                  navigate("/tradestable");
                } else {
                  enqueueSnackbar("Can't execute data from orders", {
                    variant: "error",
                  });
                  dispatch({ type: CLEAR_ERRORS });
                  dispatch(
                    getTradesFromDatabase({ user: userId }, enqueueSnackbar)
                  );
                  navigate("/tradestable");
                }
            */}
            } else {
              enqueueSnackbar("Can't connect to account", {
                variant: "error",
              });
              dispatch({ type: CLEAR_ERRORS });
           //   dispatch(
            //    getTradesFromDatabase({ user: userId }, enqueueSnackbar)
            //  );
            //  navigate("/tradestable");
            }
          
            dispatch(setTradesLoadingFinished());
          }}
        >
          Connect
        </Button>
      </DialogActions>
    </>
  );

  return (
    <MainLayout title="">
      <Stack width="100%" p={{ xs: 1, md: 2 }}>
        {loading ? (
          <Stack
            height="calc(100vh - 135px)"
            justifyContent="center"
            alignItems="center"
          >
             <Spinner/>
            <Typography>{message1}</Typography>
            <progress value={progress1} max="100"></progress>
           
          </Stack>
        ) : (
          <Card sx={{ p: 3 }}>
            <Stack direction="column" spacing={3}>
              <Typography variant="h6">
                <b>Importa los datos desde tu ERP</b>
              </Typography>
              <Stack
                direction={{ xs: "column", md: "row" }}
                alignItems={{ xs: "flex-start", md: "center" }}
                spacing={1}
              >
                <Typography minWidth={170}>
                  <b>Selecciona tu ERP:</b>
                </Typography>
                <FormControl fullWidth>
                  <Select
                    labelId="broker"
                    value={broker}
                    onChange={(e) => setBroker(e.target.value)}
                  >
                    {brokers.map((broker, index) => (
                      <MenuItem key={index} value={broker}>
                        {broker}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Stack>
              <Stack direction="row" spacing={2}>
                <Button
                  variant="contained"
                  onClick={handleClickDialogOpen}
                  disabled={broker.length === 0}
                  sx={{ bgcolor: "#0094b6" }}
                >
                  Conectar Cuenta
                </Button>
                {/*  {openSync && <SyncProgress />}   */}
             {/* 
             <Button
                  variant="contained"
                  onClick={handleRegionesAsesores}
                  disabled={broker.length === 0}
                  sx={{ bgcolor: "#0094b6" }}
                >
                  Sync regiones y asesores
                </Button>
             */}



              <div hidden={CheckedData ?  true : false}>
              <Button
          variant="contained"
       
          sx={{ bgcolor: "#0094b6" }}
          onClick={async () => {
            handleDialogClose();
            setMessage("Connecting the account to Siigo...");
            dispatch(setTradesLoading());
            const connectAccount = await axios.post(
              "/api/siigo_account",
              {
                user: userId,
                id: user_siigo,
                pass: password_siigo
              }
            );
            if (connectAccount.data.success) {
              enqueueSnackbar(
                `Successfully stored data`,
                {
                  variant: "success",
                }
              );
              navigate("/charts");
            {/*
              setMessage("Getting reports...");
              const response = await axios.post("/api/import_reports_siigo", {
                user: userId,
                saldo: connectAccount.data.saldo,
                costoV:connectAccount.data.costoV,
                costoM:connectAccount.data.costoM,
                utilidad:connectAccount.data.utilidad,
                gastosAdmon:connectAccount.data.gastosAdmon,
                gastosPer:connectAccount.data.gastosPer,
                gastosHono:connectAccount.data.gastosHono,
                gastosImp:connectAccount.data.gastosImp,
                gastosArrend:connectAccount.data.gastosArrend,
                gastosServ:connectAccount.data.gastosServ,
                gastosLegales:connectAccount.data.gastosLegales,
                gastosViaje:connectAccount.data.gastosViaje,
                gastosDiver:connectAccount.data.gastosDiver,
                margenBruto:connectAccount.data.margenBruto 
              });
          
                if (response.data.success) {
                  enqueueSnackbar(
                    `Successfully imported data`,
                    {
                      variant: "success",
                    }
                  );
                  dispatch({ type: CLEAR_ERRORS });
                  dispatch(
                    getTradesFromDatabase({ user: userId }, enqueueSnackbar)
                  );
                  navigate("/tradestable");
                } else {
                  enqueueSnackbar("Can't execute data from orders", {
                    variant: "error",
                  });
                  dispatch({ type: CLEAR_ERRORS });
                  dispatch(
                    getTradesFromDatabase({ user: userId }, enqueueSnackbar)
                  );
                  navigate("/tradestable");
                }
            */}
            } else {
              enqueueSnackbar("Can't connect to account", {
                variant: "error",
              });
              dispatch({ type: CLEAR_ERRORS });
              dispatch(
                getTradesFromDatabase({ user: userId }, enqueueSnackbar)
              );
              navigate("/charts");
            }
            dispatch(setTradesLoadingFinished());
          }}
        >
          Sync account
        </Button>
                </div>
   {/*
                   <Stack
  direction={{ xs: "column", md: "row" }}
  alignItems={{ xs: "flex-start", md: "center" }}
  spacing={1}
>
  <Typography minWidth={170}>
    <b>Select Files:</b>
  </Typography>

<FormControl sx={{ minWidth: 200 }}>
  <InputLabel>Año</InputLabel>
  <Select
    value={selectedYear}
    label="Año"
    onChange={(e) => setSelectedYear(e.target.value)}
  >
    {!filesByYear["2024"] && <MenuItem value="2024">2024</MenuItem>}
    {!filesByYear["2025"] && <MenuItem value="2025">2025</MenuItem>}
  </Select>
</FormControl>


  <Button
  variant="contained"
  component="label"
  sx={{ bgcolor: "#0094b6", ml: 2 }}
  disabled={!selectedYear} // solo habilitado si se selecciona año
>
  Adjuntar Archivos
  <input
    type="file"
    hidden
    multiple
    onChange={(e) => {
      const newFiles = Array.from(e.target.files);
      setFilesByYear((prev) => ({
        ...prev,
        [selectedYear]: prev[selectedYear]
          ? [...prev[selectedYear], ...newFiles]
          : newFiles,
      }));
    }}
  />
</Button>

</Stack>

<Button
  variant="contained"
  color="primary"
  onClick={handleFileUpload}
  disabled={filesByYear.length === 0}
>
  Sync account
</Button>
*/}
{/*
{Object.keys(filesByYear).map((year) => (
  <Stack key={year} sx={{ mt: 2 }}>
    <Typography variant="subtitle1">{`Archivos de ${year}`}</Typography>
    {filesByYear[year].map((file, index) => (
      <Typography key={index}>{file.name}</Typography>
    ))}
  </Stack>
))}
*/}

               
        
              </Stack>
              <Stack direction="column" color="dimgrey" spacing={0.5}>
               {/*
                <Typography>
                  Do you Want to add your siigo account? Please follow this steps
                </Typography>
                <Typography>
                1. Log in to your Siigo account: Access your account from the official Siigo website.
                </Typography>
                <Typography>
                2.Go to the settings section: Look for the "Settings" or "Configuration" option in the main menu.
                </Typography>
                <Typography>
                3.Select API: Within the settings, find the section dedicated to "API" or "Integrations."
                </Typography>
                <Typography>
                4.Generate credentials: If there is an option to generate new credentials, select it. This might include a button that says "Create" or "Generate."
                </Typography>
                <Typography>
                5.Fill in necessary details: You may need to provide additional information, such as the name of the application or the purpose for using the API.
                </Typography>
                <Typography>
                6.Obtain the credentials: Once generated, note down your API key and secret (if applicable). Make sure to keep them in a safe place.
                </Typography>
               
                <Typography>
                  Note: Please use the settings below to set the timezone,
                  currency and advanced settings for custom grouping of trades
                  for your auto-imported trades.
                </Typography>
                <Typography>
                  <b>
                    Note: Most connection issues can be resolved by simply
                    deleting and re-establishing your connection.
                  </b>
                </Typography>
                <Typography>
                  <b>
                    NEW: You can now set the sync from date for TD-A and other
                    brokers (for IB, use flex query history)
                  </b>
                </Typography>
                <Typography>
                  <b>
                    Deleting a connection DOES NOT delete ANY data from your
                    account.
                  </b>
                </Typography>
                */}
              </Stack>
              <Stack
                direction={{ xs: "column", md: "row" }}
                alignItems={{ xs: "flex-start", md: "center" }}
                spacing={1}
              >
              <FormControl  fullWidth>
                <InputLabel id="import-settings">
                 {/*Accounts*/}
                </InputLabel>
                {/*
                <Select
                  labelId="import-settings"
                  value={accountid}
                  label="Auto import settings"
                  defaultValue={{accountid}}
              
                  onChange={(e) => setSettings(e.target.value)}
                >
                  <option value="someOption">{accountid}</option>
                
                </Select>
                */}
                {broker?.toLowerCase() === "odoo" && (
                  <div
                    style={{
                      width: "100%",
                      marginTop: "30px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      boxSizing: "border-box",
                      padding: "0 20px",
                    }}
                  >
                    {/* TÍTULO */}
                    <Typography
                      sx={{
                        textAlign: "center",
                        marginBottom: "20px",
                        fontSize: "20px",
                      }}
                    >
                      <b>Cómo obtener los datos de conexión?</b>
                    </Typography>

                    {/* VIDEO RESPONSIVE */}
                    <video
                      controls
                      style={{
                        width: "100%",
                        maxWidth: "1100px",
                        height: "auto",
                        display: "block",
                        borderRadius: "10px",
                      }}
                    >
                      <source src="/videos/odoo-tutorial.mp4" type="video/mp4" />
                      Tu navegador no soporta la reproducción de video.
                    </video>
                    <Typography
                      sx={{
                        textAlign: "center",
                        marginBottom: "20px",
                        fontSize: "20px",
                      }}
                    >
                      <br></br>
                      <b>Cómo crear un usuario solo lectura?</b>
                    </Typography>
                  <video
                      controls
                      style={{
                        width: "100%",
                        maxWidth: "1100px",
                        height: "auto",
                        display: "block",
                        borderRadius: "10px",
                      }}
                    >
                      <source src="/videos/video_usuario_lectura_odoo.mp4" type="video/mp4" />
                      Tu navegador no soporta la reproducción de video.
                    </video>
              
                   <br></br>
                   <b>Modelos a usar</b>
                   <b>product.product, product.template,stock.quant, uom.uom, sale.order, sale.order.line, pos.order, pos.order.line, stock.move, mrp.bom, mrp.bom.line</b>

                  </div>

                )}

                <Stack   direction={{ xs: "column", md: "row" }}
                alignItems={{ xs: "flex-start", md: "center" }}
                spacing={3}>
                <Typography>
                  <b>
                   {user_siigo}
                  </b>
                </Typography>
                <Typography>
                  <b>
                  {password_siigo}
                  </b>
                </Typography>
                </Stack>
              </FormControl>
              </Stack>
            </Stack>
          </Card>
        )}
      </Stack>
      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Typography fontSize={18} my={1}>
            <b>Coloca acá los datos de conexión</b>
          </Typography>
        </DialogTitle>
        <IconButton
          onClick={handleDialogClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
        {broker === "Oanda" && renderOanda}
        {broker === "Siigo" && renderMetatrader}
        {broker === "Effi" && renderEffi}
        {broker === "Siigo inventario" && renderSiigoInventario}
        {broker === "Odoo" && renderodoo}
      </Dialog>
    </MainLayout>
  );
}
